const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Start Date",
    dataIndex: "start_date",
    render: defaultRender,
  },
  {
    title: "End Date",
    dataIndex: "end_date",
    render: defaultRender,
  },
  {
    title: "Hours",
    dataIndex: "hours",
    render: (value, record) => <p>{record?.payroll_data[0]?.hours || "--"}</p>,
  },
  {
    title: "Overtime Hours(if any)",
    dataIndex: "overtime",
    render: (value, record) => (
      <p>{record?.payroll_data[0]?.overtime_hour || "--"}</p>
    ),
  },
  {
    title: "Statutory Holiday(if any)",
    dataIndex: "statutory_holiday",
    render: (value, record) => (
      <p>{record?.payroll_data[0]?.holidays || "--"}</p>
    ),
  },
  {
    title: "Rate",
    dataIndex: "rate",
    render: (value, record) => <p>{record?.payroll_data[0]?.rate || "--"}</p>,
  },

  {
    title: "Status",
    dataIndex: "status",
    render: defaultRender,
  },
];

export default columns;
